import asyncThunk from '@/lib/asyncThunk'
import { Logging } from '@/out/logging'

type Request = Record<never, never>

export const retrieveLogging = asyncThunk<Request, Logging>({
  name: 'logging/retrieve',
  uri: '/logging',
})
